import { LuSearch } from "@/Components/Icons/Icons";
export default {
  row1 :[
  {
    column: "column1",
    rows: {
      row1: [
        {
          name: "dfrcRegnNumber",
          label: "DRFC Regn.Number",
          component: "text-field",
          width: "30%",
        },

        {
          name: "productGroup",
          label: "Product Group",
          component: "dropdown",
          width: "30%",
          endIconName: "LuChevronDown",
          iconColor: "gray-400",
          options: [
            { label: "Engineering Products", value: "Engineering Products" },
            { label: "Chemicals and allied", value: "Chemicals and allied" },
            { label: "Plastics", value: "Plastics" },
            { label: "Leather and Leather", value: "Leather and Leather" },
            { label: "Sports Goods", value: "Sports Goods" },

          ],
        },
      ],


    }
  }
]
}

